import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./ClientSlider.css";

function ClientSlider({ clients }) {
  const sortedClients = Array.isArray(clients)
    ? [...clients].sort((a, b) => a.sortOrder - b.sortOrder)
    : [];

  // Settings for react-slick
  const settings = {
    arrows: false,
    dots: false, // Hide dots
    infinite: true, // Enable infinite loop
    speed: 300, // Transition speed
    slidesToShow: 6, // Number of logos to show at once
    slidesToScroll: 1, // Number of logos to scroll
    autoplay: true, // Enable autoplay
    autoplaySpeed: 1000, // Autoplay interval
    draggable: true, // Enable dragging
    swipeToSlide: true, // Allow swiping
    pauseOnHover: false, // Continue autoplay on hover
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 4,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 2,
        },
      },
    ],
  };

  return (
    <div className="clientSlider">
      <p>
        Our <strong>Portfolio</strong>
      </p>

      <Slider {...settings} className="logo-slider">
        {sortedClients.map((logo, index) => (
          <div key={index} className="logo-container">
            <img
              src={process.env.REACT_APP_BACKEND_URL_IMAGES + logo.imageUrl}
              alt={logo.name}
              className="logo"
            />
          </div>
        ))}
      </Slider>
    </div>
  );
}

export default ClientSlider;
